
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-78bb9ab6!postcss-loader!sass-loader?sourceMap!import-glob-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./voided-item.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/components/atoms/voided-item/voided-item.vue
// module id = 593
// module chunks = 4